<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import ThisForm from "../../../components/payroll/salaryexportrecord/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": ThisForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle: this.$t('allsalaryexportrecord.editsalaryexportrecord'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadHeaderHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/salaryexportrecord/" + this.id})
        .then((res) => {
          
          for(let i = 0; i < res.data.rec.length; i++){
            res.data.rec[i].date = moment(res.data.rec[i].date).format("YYYY-MM-DD"); 
          }
          res.data.rec[0].statustimestamp =  moment(res.data.rec[0].statustimestamp).format("YYYY-MM-DD"); 
          vm.formData = res.data.rec[0];

          vm.pageTitleValue = res.data.rec[0].socsocode;
          vm.formData.userid = this.$store.getters.userId;

          //vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    loadDetailHandler() {
      const vm = this;
      console.log("id", this.id);

      return this.$store.dispatch('get', {url: "/salaryexportrecordd/" + this.id})
        .then((res) => {
          vm.formData.saleexportrecorddetail = res.data.rec;
          this.$store.dispatch('get', {url: "/salaryexportrecordref/" + this.id})
            .then((res) => {
              for(let i = 0; i < res.data.rec.length; i++){
                res.data.rec[i].date = moment(res.data.rec[i].date).format("YYYY-MM-DD"); 
              }
              vm.formData.saleexportrecordref = res.data.rec;
              console.log("rec", res.data.rec);

              // vm.loading = false;
            })
            .catch((err) => {
              vm.isErr = !vm.isErr;
              vm.errMsg = err;
            });
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
        this.$router.push({name: 'salaryexportrecordnew'});
    },

    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/salaryexportrecord/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "salaryexportrecordlist", params: { search: this.search} });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "salaryexportrecordlist" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/salaryexportrecord/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "salaryexportrecordlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    try {
      await this.loadHeaderHandler();
      await this.loadDetailHandler();
    } finally {
      this.loading = false;
    }
  },
};
</script>